import { render } from "./AssetGallery.vue?vue&type=template&id=0d206e6f&scoped=true&ts=true&lang=pug"
import script from "./AssetGallery.vue?vue&type=script&lang=ts&setup=true"
export * from "./AssetGallery.vue?vue&type=script&lang=ts&setup=true"

import "./AssetGallery.vue?vue&type=style&index=0&id=0d206e6f&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d206e6f"]])

export default __exports__